import * as z$1 from "zod/v4";
//#region src/schemas/http/space-password.ts
const SPACE_PASSWORD_MIN_LENGTH = 6;
const SPACE_PASSWORD_RATE_LIMITED_ERROR_CODE = "space.password_rate_limited";
function normalizeSpacePasswordText(password) {
	return password.trim();
}
const spacePasswordSchema = z$1.string().transform(normalizeSpacePasswordText).pipe(z$1.string().superRefine((password, context) => {
	if (password.length < 6) context.addIssue({
		code: "too_small",
		origin: "string",
		minimum: 6,
		inclusive: true
	});
}));
const createSpacePasswordBodySchema = z$1.strictObject({ password: spacePasswordSchema.optional() });
const upsertSpacePasswordBodySchema = z$1.strictObject({ password: spacePasswordSchema });
const spacePasswordStateSchema = z$1.strictObject({ passwordProtected: z$1.boolean() });
//#endregion
export { SPACE_PASSWORD_MIN_LENGTH, SPACE_PASSWORD_RATE_LIMITED_ERROR_CODE, createSpacePasswordBodySchema, normalizeSpacePasswordText, spacePasswordSchema, spacePasswordStateSchema, upsertSpacePasswordBodySchema };

//# sourceMappingURL=space-password.js.map